import React from 'react';

function GameModeSelector({ onSelectMode }) {
  return (
    <div className="flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-2xl p-8 backdrop-blur-md">
        <div className="text-center">
          <h1 className="mb-2 pb-10 text-4xl font-bold text-white">Smackdle</h1>

          <div className="space-y-4">
            <button
              onClick={() => onSelectMode('person')}
              className="w-full cursor-pointer rounded-xl bg-white/10 p-6 text-left transition-all duration-200 hover:border-zinc-500 hover:bg-white/20 hover:shadow-lg"
            >
              <div className="flex items-center gap-4">
                <div>
                  <h3 className="text-lg font-semibold text-white">Person</h3>
                  <p className="text-sm text-zinc-400">
                    Identify the person based on their attributes
                  </p>
                </div>
              </div>
            </button>

            <button
              onClick={() => onSelectMode('quote')}
              className="w-full cursor-pointer rounded-xl bg-white/10 p-6 text-left transition-all duration-200 hover:border-zinc-500 hover:bg-white/20 hover:shadow-lg"
            >
              <div className="flex items-center gap-4">
                <div>
                  <h3 className="text-lg font-semibold text-white">Quote</h3>
                  <p className="text-sm text-zinc-400">
                    Figure out who said a randomly picked quote
                  </p>
                </div>
              </div>
            </button>

            <button
              onClick={() => onSelectMode('conversation')}
              className="w-full cursor-pointer rounded-xl bg-white/10 p-6 text-left transition-all duration-200 hover:border-zinc-500 hover:bg-white/20 hover:shadow-lg"
            >
              <div className="flex items-center gap-4">
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    Conversation
                  </h3>
                  <p className="text-sm text-zinc-400">
                    Identify both people in a conversation
                  </p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GameModeSelector;
